<script setup lang="ts">
import JournalArticlePage from '@/pages/journalArticle';

definePageMeta({
  key: (route) => route.path,
});
</script>

<template>
  <JournalArticlePage />
</template>
